//3rd Party Components
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";

const ProfileIndividual = ({ name, arn, hasParticipants, standalone }) => {

    const showProfileSelector = (hasParticipants, standalone) => {
        if (hasParticipants) {
            return (
                <div className="casa-profile-link col-lg-6 col-md-12 col-xs-12 col-lg-12-align-right">
                    <ul>
                        <li><Link to={"/profiledetailsind?standalone=" +  standalone}>View profile</Link></li>
                        <li><Link to={"/profileselector?standalone=" + standalone}>Switch profile</Link></li>
                    </ul>
                </div>
            )
        }
        else {
            return (
                <div className="casa-profile-link col-lg-6 col-md-12 col-xs-12 col-lg-12-align-right">
                    <ul>
                        <li><Link to={"/profiledetailsind?standalone=" + standalone}>View profile</Link></li>
                    </ul>
                </div>
            )
        }
    }
   
    return (
        <div className="row casa-profile casa-profile-individual">
            <div className="col-lg-6 col-md-12 col-xs-12">
                <strong>{name}&nbsp;</strong>
                ARN: {arn}
            </div>
                
            {showProfileSelector(hasParticipants, standalone)}
               
        </div>

    );  

};

ProfileIndividual.propTypes = {
    name: PropTypes.string.isRequired,
    hasParticipants: PropTypes.bool.isRequired,
    standalone: PropTypes.bool.isRequired
};

export default ProfileIndividual;

